<div *ngIf="isDisplayRetention && !isCreateRetention && !isUpdateRetention">
    <div class="card mt-5" *ngIf="retentionApplied">
        <div class="card-body">
            <div>Retention has been applied.</div>
            <button class="buttonclass" style="margin: 1em;float: right;" mat-raised-button
                (click)="displayPage()">Back</button>

        </div>
    </div>
    <div *ngIf="!retentionApplied">
        <div class="Tabletitle">
            <span> Retention Groups ({{retentionGroupsCount}})</span>
        </div>

        <div class="row">
            <button class="actionButton m-1" mat-raised-button (click)="createRetentionGroup($event)">Create Retention
                Group</button>
                <div class="input-group-sm mt-2 input-group col-6">
                    <input *ngIf="allRetentionGroup" class="form-control" type="search" (keyup)="applyFilter($event)" placeholder="Filter">
                </div>
            <!-- <mat-form-field class="element-filter" *ngIf="allRetentionGroup">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)">
            </mat-form-field> -->
        </div>

        <div *ngIf="!allRetentionGroup && noRetentionGroups">
            No Retention Groups to display.
        </div>

        <div class="table-container mat-elevation-z8"
            *ngIf="isDisplayRetention && !isCreateRetention && !isUpdateRetention && allRetentionGroup">
            <form [formGroup]="reApplyForm">
                <table mat-table matSort [dataSource]="allRetentionGroup" matSortActive="name" matSortDirection="asc"
                    aria-describedby="retention-table">

                    <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition"
    -->

                    <!-- Hold Name Column -->
                    <ng-container matColumnDef="name">
                        <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td mat-cell *matCellDef="let retention"> {{retention.name}}
                            <mat-icon title="Descripion" style="transform: scale(0.75);" #authMenu
                                [matMenuTriggerFor]="menu">
                                info</mat-icon>
                            <mat-menu class="my-menu pl-2 p-1" #menu="matMenu">
                                {{retention.description}}
                            </mat-menu>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="disposal_policy_id" style="width: 200px;">
                        <th id="disposal_policy_id" mat-header-cell *matHeaderCellDef mat-sort-header>Disposal Policy
                        </th>
                        <td mat-cell *matCellDef="let retention"><span *ngFor="let policy of allPolicies;">
                                <span *ngIf="policy.id == retention.disposal_policy_id">
                                    {{policy.name}}
                                </span>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container *ngIf="archive" matColumnDef="archival_policy_id">
                        <th id="disposal_policy_id" mat-header-cell *matHeaderCellDef mat-sort-header>Archival Policy
                        </th>
                        <td mat-cell *matCellDef="let retention"><span *ngFor="let policy of allPolicies;">
                                <span *ngIf="policy.id == retention.archival_policy_id">
                                    {{policy.name}}
                                </span>
                            </span>
                        </td>
                    </ng-container>

                    <!-- Date Created Column -->
                    <ng-container matColumnDef="datecreated">
                        <th id="dateCreated" mat-header-cell *matHeaderCellDef mat-sort-header> Date Created </th>
                        <td mat-cell *matCellDef="let retention"> {{retention.create_date | date}} </td>
                    </ng-container>

                    <!-- Created By Column -->
                    <ng-container matColumnDef="created_by">
                        <th id="createdBy" mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                        <td mat-cell *matCellDef="let retention"> {{retention.created_by}} </td>
                    </ng-container>

                    <!-- Active Column -->
                    <ng-container matColumnDef="reApply">
                        <th id="reApply" *matHeaderCellDef class="mat-header-sortless"> Re-Apply </th>
                        <td mat-cell *matCellDef="let retention;">
                            <mat-slide-toggle formControlName="reApply"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="actions">
                        <th id="actions" *matHeaderCellDef class="mat-header-sortless"> Actions </th>
                        <td mat-cell *matCellDef="let retention">
                            <mat-icon title="Apply Retention" class="mr-1"
                                (click)="applyRetention($event, retention, reApplyForm.value)">play_arrow</mat-icon>
                            <mat-icon title="Update Retention Group" (click)="updateRetention($event, retention)">edit
                            </mat-icon>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
            </form>
        </div>
    </div>
</div>
<div *ngIf="!isDisplayRetention && isCreateRetention && !isUpdateRetention">
    <div class="Tabletitle">Create Retention Group</div>

    <div class="card-body" *ngIf="!retentionCreated">
        <form [formGroup]="createFormData">
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Name</span>

                </div>
                <input type="text" class="form-control" id="retention-name" formControlName="name" name="retention-name"
                    [(ngModel)]="name">
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Disposal Policy</span>
                </div>
                <mat-select class="form-control" id="retention-policyid" formControlName="disposal_policy_id"
                    (selectionChange)="checkPolicyType(disposalPolicyId)" (ngModelChange)="disposalPolicyId"
                    [(ngModel)]="disposalPolicyId" name="retention-policyid" convert-to-number required>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                            [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let policy of allPolicies|stringFilter:searchCtrl:'name'" [value]="policy.id">
                        {{policy.name}}
                    </mat-option>
                </mat-select>
            </div>

            <div *ngIf="archive">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Archive Documents</span>
                    </div>
                    <span>
                        <mat-slide-toggle name="to-Archive-toggle" formControlName="archive" [(ngModel)]="toArchive"
                            style="padding-left: 30%;">
                        </mat-slide-toggle>
                    </span>
                </div>

                <div *ngIf="toArchive" class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Archival Policy</span>
                    </div>
                    <mat-select class="form-control" id="archival-policyid" formControlName="archival_policy_id"
                        (ngModelChange)="archivalPolicyId" [(ngModel)]="archivalPolicyId" name="archival-policyid"
                        convert-to-number required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let policy of allPolicies|stringFilter:searchCtrl:'name'"
                            [value]="policy.id">
                            {{policy.name}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Categories</span>
                </div>
                <mat-select [(ngModel)]="categories" formControlName="categories" (ngModelChange)="categories"
                    (selectionChange)="getDisplayListData(categories)" multiple class="form-control">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                            [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let category of allCategories|stringFilter:searchCtrl:'name'"
                        [value]="category.id">
                        {{category.name}}</mat-option>
                </mat-select>
            </div>

            <div class="input-group-sm mb-3 input-group col-12"
                title="Example: 'meta_data->'properties'->>'City' = 'Chicago''">
                <div class="input-group-prepend">
                    <span class="input-group-text">Criteria</span>
                </div>
                <input formControlName="criteria" class="form-control" id="retention-criteria" [(ngModel)]="query"
                    name="retention-criteria" [readonly]="true" required>
            </div>
            <div class="col-lg-12 control-section">
                <ejs-querybuilder #querybuilder width="70%" [dataSource]="allCategoryProperties"
                    [showButtons]="showButtons" [rule]="importRules" [columns]="filter" (dataBound)='dataBound()'
                    (created)="createdControl()">
                </ejs-querybuilder>
                <button class="mb-3" style="float: right;" mat-stroked-button (click)=queryBuilder()>Generate
                    Criteria</button>
            </div>

            <div *ngIf="!isFixed" class="input-group">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Retention Date</span>
                    </div>
                    <mat-select class="form-control" id="retention-retentiondate" formControlName="retentiondate"
                        [(ngModel)]="retentionDate" name="retention-retentiondate" required>
                        <mat-option *ngFor="let retentiondate of allRetentionDate" [value]="retentiondate">
                            {{retentiondate}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>


            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Description</span>
                </div>
                <textarea type="text" class="form-control" id="retention-description" formControlName="description"
                    name="retention-description" [(ngModel)]="description"></textarea>
            </div>
            <button mat-raised-button class="backButton m-2" style="float: right" (click)="displayPage()"
                mat-button>Back</button>
            <button mat-raised-button class="actionButton m-2" style="float: right" (click)="saveCreateRetention()"
                mat-button>Create</button>
        </form>
    </div>

    <div class="card mt-5" *ngIf="retentionCreated">
        <div class="card-body">
            <div>Retention Group <strong>{{fetchedName}} </strong>has been created.</div>
            <button class="buttonclass" style="margin: 1em;float: right;" mat-raised-button
                (click)="displayPage()">Back</button>

        </div>
    </div>


</div>


<div *ngIf="!isDisplayRetention && !isCreateRetention && isUpdateRetention">
    <div class="Tabletitle">Update Retention Group</div>
    <div class="card-body" *ngIf="!retentionUpdated">
        <form [formGroup]="createFormData">
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Name</span>
                </div>
                <input type="text" class="form-control" id="retention-name" name="retention-name" formControlName="name"
                    [(ngModel)]="fetchedName">
            </div>



            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Disposal Policy</span>
                </div>

                <mat-select class="form-control" id="disposal-policyid" formControlName="disposal_policy_id"
                    (selectionChange)="checkPolicyType(fetchedDisposalPolicyId)"
                    (ngModelChange)="fetchedDisposalPolicyId" [(ngModel)]="fetchedDisposalPolicyId"
                    name="disposal-policyid" convert-to-number required>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                            [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let policy of allPolicies" [value]="policy.id">
                        {{policy.name}}
                    </mat-option>
                </mat-select>
            </div>

            <div *ngIf="archive">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Archive Documents</span>
                    </div>
                    <span>
                        <mat-slide-toggle name="to-Archive-toggle" formControlName="archive"
                            [(ngModel)]="fetchedArchive" style="padding-left: 30%;">
                        </mat-slide-toggle>
                    </span>
                </div>

                <div *ngIf="fetchedArchive" class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Archival Policy</span>
                    </div>
                    <mat-select class="form-control" id="archival-policyid" formControlName="archival_policy_id"
                        (ngModelChange)="fetchedArchivalPolicyId" [(ngModel)]="fetchedArchivalPolicyId"
                        name="archival-policyid" convert-to-number required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let policy of allPolicies|stringFilter:searchCtrl:'name'"
                            [value]="policy.id">
                            {{policy.name}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Categories</span>
                </div>
                <mat-select [(ngModel)]="fetchedCategories" formControlName="categories"
                    (ngModelChange)="fetchedCategories" (selectionChange)="getDisplayListData(fetchedCategories)"
                    multiple class="form-control">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                            [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let category of allCategories|stringFilter:searchCtrl:'name'"
                        [value]="category.id">
                        {{category.name}}</mat-option>
                </mat-select>
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Criteria</span>
                </div>
                <input placeholder="Example: 'meta_data->'properties'->>'City' = 'Chicago''" formControlName="criteria"
                    class="form-control" id="retention-criteria" [(ngModel)]="fetchedCriteria" name="retention-criteria"
                    required>

            </div>

            <div *ngIf="!isFixed" class="input-group">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Retention Date</span>
                    </div>
                    <select class="form-control" id="retention-retentiondate" formControlName="retentiondate"
                        [(ngModel)]="fetchedRetentionDate" name="retention-retentiondate" required>
                        <option *ngFor="let retentiondate of allRetentionDate" [value]="retentiondate">
                            {{retentiondate}}
                        </option>
                    </select>
                </div>
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Description</span>
                </div>
                <textarea type="text" class="form-control" id="retention-description" formControlName="description"
                    name="retention-description" [(ngModel)]="fetchedDescription"></textarea>
            </div>

            <div class="button-class">
                <button mat-raised-button (click)="saveUpdateRetention()" class="actionButton m-3">Update</button>
                <button mat-raised-button (click)="displayPage()" class="backButton m-2">Back</button>
            </div>
        </form>
    </div>

    <div class="card mt-5" *ngIf="retentionUpdated">
        <div class="card-body">
            <div>Retention Group <strong>{{fetchedName}} </strong>has been updated.</div>
            <button class="buttonclass" style="margin: 1em;float: right;" mat-raised-button
                (click)="displayPage()">Back</button>

        </div>
    </div>
</div>